import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qe-id"]
const _hoisted_2 = { key: 0 }

import { computed } from 'vue'
import { SeasonRanking } from '@/model/ranking/Season'
import { TableFilter } from '@/model/ranking/TableFilter'
import CTicketIcon from '@/components/CTicketIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CTableRow',
  props: {
    ranking: {},
    highlighted: { type: Boolean, default: false },
    type: { default: TableFilter.DEFAULT }
  },
  setup(__props: any) {

const props = __props

const isTicketColumnRendered = computed(() => {
  return props.type === TableFilter.DEFAULT
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass({ highlighted: _ctx.highlighted }),
    key: _ctx.ranking.playerName,
    "data-qe-id": !!_ctx.highlighted ? 'tr-data-highlighted' : 'tr-data'
  }, [
    _createElementVNode("td", null, _toDisplayString(_ctx.ranking.seasonRank), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.ranking.playerName), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.ranking.seasonScore), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.ranking.seasonPrize), 1),
    (isTicketColumnRendered.value)
      ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
          (_ctx.ranking.ticketInfo)
            ? (_openBlock(), _createBlock(CTicketIcon, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})